import {
  collection,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
} from 'firebase/firestore';
import { db } from './firebase';

export interface CustomCategory {
  id: string;
  name: string;
  type: 'gain' | 'expense';
  color: string;
  createdAt: Date;
}

export type CustomCategoryInput = Omit<CustomCategory, 'id' | 'createdAt'>;

const getCategoriesCollection = (userId: string) =>
  collection(db, `users/${userId}/customCategories`);

export async function getCustomCategories(userId: string): Promise<CustomCategory[]> {
  try {
    const col = getCategoriesCollection(userId);
    const q = query(col, orderBy('createdAt', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((d) => ({
      id: d.id,
      ...d.data(),
      createdAt: d.data().createdAt?.toDate?.() || new Date(),
    })) as CustomCategory[];
  } catch (error) {
    console.error('Error getting custom categories:', error);
    return [];
  }
}

export async function addCustomCategory(
  userId: string,
  category: CustomCategoryInput
): Promise<string> {
  const col = getCategoriesCollection(userId);
  const docRef = await addDoc(col, {
    ...category,
    createdAt: serverTimestamp(),
  });
  return docRef.id;
}

export async function updateCustomCategory(
  userId: string,
  categoryId: string,
  updates: Partial<CustomCategoryInput>
): Promise<void> {
  const catDoc = doc(getCategoriesCollection(userId), categoryId);
  await updateDoc(catDoc, updates);
}

export async function deleteCustomCategory(
  userId: string,
  categoryId: string
): Promise<void> {
  const catDoc = doc(getCategoriesCollection(userId), categoryId);
  await deleteDoc(catDoc);
}
